var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"resume-extra-charge"},[(_vm.title)?_c('p',{staticClass:"resume__title semibold"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._l((_vm.extra),function(item,index){return _c('resume-extra-item',{key:_vm._uid+'_item_'+index,attrs:{"extra":item}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }